import React from "react";
import Card from "components/card";
import Button from "components/button/Button";
import CommonModal from "components/modals/Modal";
import { createPortal } from "react-dom";
import { useDisclosure } from "@chakra-ui/hooks";
import { useNavigate } from "react-router-dom";
import { numericFormatter } from "react-number-format";
import { FaPercentage, FaTrash } from "react-icons/fa";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";
import { IDiscounts } from "views/admin/discounts/types/discounts.interface";
import { DiscountType } from "constants/discount";
import { Badge } from "@chakra-ui/react";

interface IDiscountCardProps extends IDiscounts {
  onDelete?: (slug: string) => void;
}

const DiscountCard: React.FC<IDiscountCardProps> = (props) => {
  const navigate = useNavigate();
  const { discount, slug, name, image_thumbnail, price, onDelete } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalAction, setModalAction] = React.useState<
    "show" | "confirmation"
  >();

  return (
    <>
      <Card extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white`}>
        <div className="h-full w-full">
          <div className="relative mb-1 w-full overflow-hidden">
            {image_thumbnail ? (
              <img
                src={
                  image_thumbnail
                    ? image_thumbnail.includes("https://")
                      ? image_thumbnail
                      : `${process.env.REACT_APP_PUBLIC_URL}/${image_thumbnail}`
                    : "https://placehold.co/600x400?text=No+Thumbnail"
                }
                className="mb-3 h-56 w-full rounded-xl object-cover object-center"
                alt={name}
              />
            ) : (
              <div className="flex h-56 w-full items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
                <FaPercentage className="h-12 w-12 text-brand-500" />
              </div>
            )}
          </div>

          <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
            <div className="flex w-full">
              <div className="mb-2 flex flex-col overflow-hidden">
                <p className="truncate text-lg font-bold text-navy-700 dark:text-white">
                  {" "}
                  {name}
                </p>
                <div className="flex flex-col">
                  <p className="mt-1 text-sm font-medium text-gray-600">
                    Berlaku :{" "}
                    <span className="text-brand-500">
                      {new Date(discount.start_at).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        timeZone: "Asia/Jakarta",
                        timeZoneName: "short",
                      })}{" "}
                      -{" "}
                      {new Date(discount.end_at).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        timeZone: "Asia/Jakarta",
                        timeZoneName: "short",
                      })}{" "}
                    </span>
                  </p>
                </div>
                <div className="mt-3 flex flex-col items-start">
                  <p className="text-sm font-bold text-red-700 line-through dark:text-white">
                    {numericFormatter(price.price.toString(), {
                      decimalSeparator: ",",
                      thousandSeparator: ".",
                      prefix: "Rp",
                    })}
                  </p>
                  <h3 className="text-lg font-bold text-brand-500 dark:text-white">
                    {numericFormatter(price.price_after_discount.toString(), {
                      decimalSeparator: ",",
                      thousandSeparator: ".",
                      prefix: "Rp",
                    })}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
            <div className="flex">
              <p className="mb-2 text-lg font-bold text-navy-700 dark:text-white">
                {/* {code} */}
              </p>
            </div>
            <div className="flex items-center justify-between gap-2">
              <Button
                size="fit"
                children={
                  <div className="flex h-5 items-center">
                    <FaTrash className="text-xs text-white" />
                  </div>
                }
                variant="danger"
                onClick={() => {
                  setModalAction("confirmation");
                  onOpen();
                }}
              />
              <Button
                size="fit"
                children="Edit"
                variant="gray"
                onClick={() => {
                  navigate(`/admin/discounts/edit/${slug}`);
                }}
              />
              <Button
                size="fit"
                children="Detail"
                variant="primary"
                onClick={() => {
                  setModalAction("show");
                  onOpen();
                }}
              />
            </div>
          </div>
        </div>
      </Card>
      {createPortal(
        <CommonModal
          size="2xl"
          children={
            <div>
              <ModalHeader>
                {modalAction === "show" ? "Detail Kupon" : "Konfirmasi"}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {modalAction === "show" ? (
                  <div className={`flex h-full w-full flex-col bg-white`}>
                    <div className="h-full w-full">
                      <div className="relative mb-1 w-full overflow-hidden">
                        {image_thumbnail ? (
                          <img
                            src={
                              image_thumbnail
                                ? image_thumbnail.includes("https://")
                                  ? image_thumbnail
                                  : `${process.env.REACT_APP_PUBLIC_URL}/${image_thumbnail}`
                                : "https://placehold.co/600x400?text=No+Thumbnail"
                            }
                            className="mb-3 h-full w-full rounded-xl object-cover object-center 3xl:h-full 3xl:w-full"
                            alt=""
                          />
                        ) : (
                          <div className="flex h-56 w-full items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
                            <FaPercentage className="h-12 w-12 text-brand-500" />
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <p className="text-lg font-bold text-navy-700 dark:text-white">
                          {" "}
                          {name}{" "}
                        </p>
                      </div>
                      <div className="flex flex-col gap-2">
                        <div className="flex flex-col gap-1">
                          <p className="mt-1 font-medium text-gray-600">
                            Status:
                          </p>
                          <Badge
                            colorScheme={`${
                              discount.is_active ? "green" : "gray"
                            }`}
                            className="w-fit"
                          >
                            {discount.is_active ? "Aktif" : "Tidak Aktif"}
                          </Badge>
                        </div>
                        <div className="flex flex-col gap-1">
                          <p className="mt-1 font-medium text-gray-600">
                            Berlaku:
                          </p>
                          <span className="font-medium text-brand-500">
                            {new Date(discount.start_at).toLocaleDateString(
                              "id-ID",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                timeZone: "Asia/Jakarta",
                                timeZoneName: "short",
                              }
                            )}{" "}
                            -{" "}
                            {new Date(discount.end_at).toLocaleDateString(
                              "id-ID",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                timeZone: "Asia/Jakarta",
                                timeZoneName: "short",
                              }
                            )}{" "}
                          </span>
                        </div>
                        <div className="flex gap-5">
                          <div className="flex flex-col gap-1">
                            <p className="mt-1 text-sm font-medium text-gray-600">
                              Potongan:
                            </p>
                            <p className="font-medium text-navy-700">
                              {price.type === DiscountType.PERCENTAGE ? (
                                <span>{price.discount}%</span>
                              ) : (
                                <span>
                                  {numericFormatter(price.discount.toString(), {
                                    decimalSeparator: ",",
                                    thousandSeparator: ".",
                                    prefix: "Rp",
                                  })}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="flex flex-col items-start">
                          <p className="mt-1 text-sm font-medium text-gray-600">
                            Harga:
                          </p>
                          <p className="text-sm font-bold text-red-700 line-through dark:text-white">
                            {numericFormatter(price.price.toString(), {
                              decimalSeparator: ",",
                              thousandSeparator: ".",
                              prefix: "Rp",
                            })}
                          </p>
                          <h3 className="text-lg font-bold text-brand-500 dark:text-white">
                            {numericFormatter(
                              price.price_after_discount.toString(),
                              {
                                decimalSeparator: ",",
                                thousandSeparator: ".",
                                prefix: "Rp",
                              }
                            )}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-3">
                    <p className="text-base text-gray-700 dark:text-white">
                      Apakah anda yakin ingin menghapus promo <br />
                      <span className="text-brand-500">{name}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                {modalAction === "show" ? (
                  <Button
                    variant="gray"
                    children="Tutup"
                    size="fit"
                    onClick={onClose}
                  />
                ) : (
                  <div className="flex gap-3">
                    <Button
                      size="fit"
                      children="Batal"
                      variant="gray"
                      onClick={onClose}
                    />
                    <Button
                      size="fit"
                      children={<span className="text-white">Ya, hapus</span>}
                      variant="danger"
                      onClick={() => {
                        onClose();
                        onDelete && onDelete(slug);
                      }}
                    />
                  </div>
                )}
              </ModalFooter>
            </div>
          }
          isOpen={isOpen}
          onClose={onClose}
        />,
        document.body
      )}
    </>
  );
};

export default DiscountCard;
